import { render } from "./Adjective.vue?vue&type=template&id=a32aca36&scoped=true"
import script from "./Adjective.vue?vue&type=script&lang=js"
export * from "./Adjective.vue?vue&type=script&lang=js"

import "./Adjective.vue?vue&type=style&index=0&id=a32aca36&scoped=true&lang=css"

import exportComponent from "C:\\Users\\cell8\\Desktop\\portfolio\\rhymeasaurus\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a32aca36"]])

export default __exports__